"use client"

import { HttpTypes } from "@medusajs/types"
import ProductPrice from "../components/product-price"
import ProductVariantsTable from "../components/product-variants-table"
import { B2BCustomer } from "@/types/global"
import { WarehouseMetadata } from "@/lib/data/inventory"

type ProductActionsWrapperProps = {
  product: HttpTypes.StoreProduct
  region: HttpTypes.StoreRegion
  customer?: B2BCustomer | null
  warehouseStock?: Record<string, number>
  warehouseMetadata?: Record<string, WarehouseMetadata>
  isOutOfStock?: boolean
}

/**
 * Wraps product actions. When out of stock, shows only price; ProductFacts below
 * handles the restock notification UI (no duplication).
 */
export default function ProductActionsWrapper({
  product,
  region,
  customer,
  warehouseStock,
  warehouseMetadata,
  isOutOfStock = false,
}: ProductActionsWrapperProps) {
  return (
    <div className="flex flex-col gap-y-2 w-full">
      <ProductPrice product={product} />
      {!isOutOfStock && (
        <ProductVariantsTable
          product={product}
          region={region}
          warehouseStock={warehouseStock}
          warehouseMetadata={warehouseMetadata}
        />
      )}
    </div>
  )
}
